import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const EarnAndBurnSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$earnAndBurnSection' });
  const { t: tLink } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$earnAndBurnSection',
  });

  // TODO: Implement an state for displaying the HP Earn and Burn section or not

  return (
    <section id="hp-earn-and-burn" className="hp-section earn-and-burn">
      <div className="earn-and-burn-hp hp-content-wrapper">
        <picture>
          <img
            loading="lazy"
            data-src="images/misc/All-Logo.png"
            alt="Accor Earn And Burn Logo"
            src="images/homePage/misc/All-Logo.png"
            width={128}
            height={79}
          />
        </picture>
        <p className="earn-and-burn-copy hidden visible animation fadeInUp">
          <span>
            {t('firstLineCopy')}
            <strong>{t('firstLineCopyStrong')}</strong>
          </span>
          <span>{t('secondLineCopy')}</span>
          <span>{t('thirdLineCopy')}</span>
        </p>
        <a
          href={tLink('joinAll')}
          target="_blank"
          rel="noreferrer"
          data-event-name="cta_enroll"
          data-event-enroll-context="loyalty"
          data-event-cta-name="join all"
        >
          <button className="btn-earn-burn hidden visible animation fadeInUp" type="button">
            {t('joinAllButton')}
          </button>
        </a>
      </div>
    </section>
  );
};

export default EarnAndBurnSection;
